var map = {
	"./report-img-egg-01-pre@2x.png": "V2MM",
	"./report-img-egg-02-pre@2x.png": "XVhc",
	"./report-img-egg-03-pre@2x.png": "r31s",
	"./report-img-egg-04-pre@2x.png": "S3fL"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6tRH";


//////////////////
// WEBPACK FOOTER
// ./src/components/Result/imgs ^\.\/report\-img\-egg\-0.*\-pre@2x\.png$
// module id = 6tRH
// module chunks = 1